import { useMutationRunQsraAnalysis } from 'api/mutations/runQsraAnalysis.mutate';

export const useRunQsraFormProvider = () => {
    return {
        api: {
            runQsraAnalysis: {
                instance: useMutationRunQsraAnalysis(),
            },
        },
    };
};
